import Amplify, { API, Auth, Cache, Storage } from 'aws-amplify'
import awsconfig from '../aws-exports.js'

Amplify.configure(awsconfig)
Storage.configure(awsconfig.Storage.common)



export default {
  methods: {
    /**
     * ログアウト
     */
     signOut () {
      Auth.signOut()
        .then(() => {
          this.$store.commit('header/setUser', null)
          this.$store.commit('auth/logout')
          Cache.clear()
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    /**
     * GET APIを呼び出す
     * @param {string} apiName API名
     * @param {string} path APIのパス
     * @param {Dict} data 送信データ
     * @param {Function} errorCallback エラー時の処理
     * @return APIの戻り値
     */
    async getData2 (apiName, path, data = {}, errorCallback = null) {
      // IDトークン更新
      const idToken = await this.refreshIdToken2()
      if (!idToken /* || !this.checkLoginTime() */) {
        return null // エラー：IDトークンが更新できない、またはサービス時間外
      }

      const opt = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': idToken,
        },
        response: true,
        queryStringParameters: data
      }

      const response = await API.get(apiName, path, opt).catch(e => this.apiError2(e, errorCallback))
      return response.data.result
    },
    /**
     * POST APIを呼び出す
     * @param {string} apiName API名
     * @param {string} path APIのパス
     * @param {Dict} data 送信データ
     * @param {Function} errorCallback エラー時の処理
     * @return APIの戻り値
     */
    async postData2 (apiName, path, data, errorCallback = null) {
      // IDトークン更新
      const idToken = await this.refreshIdToken2()
      if (!idToken /* || !this.checkLoginTime() */) {
        return null // エラー：IDトークンが更新できない、またはサービス時間外
      }

      const opt = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': idToken,
        },
        response: true,
        body: data
      }

      const response = await API.post(apiName, path, opt).catch(e => this.apiError2(e, errorCallback))
      return response.data.result
    },
    /**
     * PUT APIを呼び出す
     * @param {string} apiName API名
     * @param {string} path APIのパス
     * @param {Dict} data 送信データ
     * @param {Function} errorCallback エラー時の処理
     * @return APIの戻り値
     */
    async putData2 (apiName, path, data, errorCallback = null) {
      // IDトークン更新
      const idToken = await this.refreshIdToken2()
      if (!idToken || !this.checkLoginTime()) {
        return null // エラー：IDトークンが更新できない、またはサービス時間外
      }

      const opt = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': idToken,
        },
        response: true,
        body: data
      }

      const response = await API.put(apiName, path, opt).catch(e => this.apiError2(e, errorCallback))
      return response.data.result
    },
    /**
     * DELETE APIを呼び出す
     * @param {string} apiName API名
     * @param {string} path APIのパス
     * @param {Dict} data 送信データ
     * @param {Function} errorCallback エラー時の処理
     * @return APIの戻り値
     */
    async deleteData2 (apiName, path, data = {}, errorCallback = null) {
      // IDトークン更新
      const idToken = await this.refreshIdToken2()
      if (!idToken /* || !this.checkLoginTime() */) {
        return null // エラー：IDトークンが更新できない、またはサービス時間外
      }

      const opt = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': idToken,
        },
        response: true,
        body: data
      }

      const response = await API.del(apiName, path, opt).catch(e => this.apiError2(e, errorCallback))
      return response.data.result
    },
    /**
     * 複数APIを非同期で呼び出す
     * @param {Object} requests 呼ぶAPIと呼び出し後の関数の配列
     * @param {Function} errorCallback エラー時の処理
     * @return APIの戻り値
     */
    async multiRequest2 (requests, errorCallback = null) {
      // IDトークン更新
      const idToken = await this.refreshIdToken2()
      if (!idToken || !this.checkLoginTime()) {
        return null // エラー：IDトークンが更新できない、またはサービス時間外
      }

      const processes = []

      requests.forEach(request => {
        processes.push(request.process)
      })

      const results = await Promise.all(processes).catch(e => this.apiError2(e, errorCallback))
      for (let i = 0; i < requests.length; i++) {
        requests[i].callback(results[i])
      }
    },
    /**
     * API呼び出し後のエラーを処理する
     * @param {Object} e エラー
     * @param {Function} errorCallback エラー時の処理
     */
    apiError2 (e, errorCallback = null) {
      console.log(e)

      if ((e.toString() === 'Error: Network Error') || (e.response && e.response.status === 401)) {
        this.$store.commit('error/setNetworkErrorModalShow', true)
      } else if (e.response && e.response.status === 403) {
        this.$store.commit('error/setAuthErrorModalShow', true)
      } else {
        const error = e.response.data.error
        error.status = e.response.status
        this.$store.commit('error/setCommonErrorModalShow', error)
      }

      if (errorCallback) {
        errorCallback()
      }
    },
    /**
     * IDトークンリフレッシュ
     */
    async refreshIdToken2 () {
      try {
        const data = await Auth.currentAuthenticatedUser()
        if (data && data.signInUserSession) {
            await this.$store.commit('auth/login', data)
          return data.signInUserSession.idToken.jwtToken
        } else {
          const company_cd = this.$store.state.setting.companyCd
          const user_name = this.$store.state.setting.userName
          const password = this.$store.state.setting.password

          const data = await Auth.signIn(`${company_cd}#${user_name}`, password)

          this.$store.commit('auth/login', data)

          return data.signInUserSession.idToken.jwtToken
        }
      } catch (e) {
        // this.$store.commit('error/setAuthErrorModalShow', true)
        const company_cd = this.$store.state.setting.companyCd
        const user_name = this.$store.state.setting.userName
        const password = this.$store.state.setting.password

        try {
            const data = await Auth.signIn(`${company_cd}#${user_name}`, password)
            this.$store.commit('auth/login', data)
            return data.signInUserSession.idToken.jwtToken
        } catch (e) {
            console.log(e)
            // this.$store.commit('error/setAuthErrorModalShow', true)
            return null
        }
      }
    },
  }
}
